import { render, staticRenderFns } from "./batch-modifying.vue?vue&type=template&id=5907d295&scoped=true"
import script from "./batch-modifying.vue?vue&type=script&lang=ts"
export * from "./batch-modifying.vue?vue&type=script&lang=ts"
import style0 from "./batch-modifying.vue?vue&type=style&index=0&id=5907d295&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5907d295",
  null
  
)

export default component.exports